import React, {useMemo, useState} from "react"
import Layout from "@/features/management-v2/layout/Layout";
import {CustomUserFieldsForm} from "@/features/management-v2/custom-user-fields/CustomUserFieldsForm";
import {useAuth} from "@/context/user";
import {ClientSelectV2} from "@/lib/clients/ClientSelectV2";
import {useCustomUserFields} from "@/hooks/useCustomUserFields";


export function CustomUserFieldsPage() {

    const {isSuperAdmin} = useAuth()

    const [clientID, setClientID] = useState<string>()

    const {fields, error, loading} = useCustomUserFields(clientID)

    const show = useMemo(() => {
        if (error || loading) return false
        if (!isSuperAdmin) return true
        return !!clientID
    }, [isSuperAdmin, clientID, error, loading])


    return (
        <Layout active={"custom-user-fields"}>
            <div className="flex flex-col gap-8">
                <div className="bg-white shadow-md p-4 w-1/2 flex flex-col gap-8">
                    <p className="text-md text-left pb-2 font-semibold">
                        Manage Custom User Fields
                    </p>

                    {isSuperAdmin && (
                        <ClientSelectV2 onChange={(client) => setClientID(client?.id)}/>
                    )}


                    {show && (
                        <CustomUserFieldsForm initialValue={fields} clientID={clientID}/>
                    )}
                </div>
            </div>
        </Layout>
    )
}